export const NO_ANSWER_TIMEOUT_MS = 60_000

export type CallWaitOptions = {
  resolveOn?: 'accepted' | 'confirmed'
  timeoutMs?: number
}

export const DEFAULT_CALL_WAIT_OPTIONS: Required<CallWaitOptions> = {
  resolveOn: 'accepted',
  timeoutMs: NO_ANSWER_TIMEOUT_MS,
}

/** SIP/JsSIP causes that settle callAsync without meaning a client failure toast. */
const EXPECTED_CALL_ASYNC_REJECTIONS = new Set([
  'Canceled',
  'Terminated',
  'Busy',
  'Rejected',
  'Redirected',
  'Unavailable',
  'Not Found',
  'No Answer',
  'Expires',
  'No ACK',
])

export const isExpectedCallAsyncRejection = (error: unknown): boolean => {
  if (typeof error === 'string') {
    return EXPECTED_CALL_ASYNC_REJECTIONS.has(error)
  }

  if (error && typeof error === 'object' && 'cause' in error) {
    const cause = (error as { cause?: unknown }).cause
    return typeof cause === 'string' && EXPECTED_CALL_ASYNC_REJECTIONS.has(cause)
  }

  return false
}
